import { useSocket } from '../contexts/SocketContext';

const FORM_LABELS = {
  'scenario': 'Scenario',
  'exercise-builder': 'Exercise Builder',
  'comms-plan': 'Comms Freqs',
  'radio-reqmts-worksheet': 'Radio Reqmts',
  'comms-log': 'Comms Log',
  'food-unit': 'Food Unit',
  'facilities-unit': 'Facilities Unit',
  'veh-equip-inventory': 'Veh/Equip Inv.',
  'cost-unit': 'Cost Unit',
  'time-unit': 'Time Unit',
  'procurement-unit': 'Procurement Unit',
  'comp-claims-unit': 'Comp & Claims',
  'med-aid-stn': 'Med Aid Station',
  'med-transport': 'Med Transport',
  'hospitals': 'Hospitals',
  'med-procedures': 'Med Procedures',
  'after-action-report': 'After Action Report',
};

const COLORS = [
  '#3b82f6', '#10b981', '#f59e0b', '#ef4444',
  '#8b5cf6', '#ec4899', '#06b6d4', '#84cc16',
];

const getColor = (index) => COLORS[index % COLORS.length];

const OnlinePresence = () => {
  const socket = useSocket();
  if (!socket) return null;

  const { connected, onlineUsers } = socket;

  if (!connected || onlineUsers.length === 0) return null;

  return (
    <div className="flex items-center gap-2" data-testid="online-presence">
      <div className={`w-2 h-2 rounded-full ${connected ? 'bg-green-500' : 'bg-red-500'}`} />
      <span className="text-xs text-gray-400 mr-1">Online:</span>
      <div className="flex -space-x-2">
        {onlineUsers.map((user, i) => (
          <div
            key={user.user_id}
            className="relative group"
          >
            <div
              className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white border-2 border-gray-800 cursor-default"
              style={{ backgroundColor: getColor(i) }}
              title={`${user.user_name}${user.form_id ? ` — ${FORM_LABELS[user.form_id] || user.form_id}` : ''}`}
            >
              {(user.user_name || '?').charAt(0).toUpperCase()}
            </div>
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 border border-gray-600 rounded text-xs text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
              {user.user_name}
              {user.form_id && (
                <span className="text-amber-400 ml-1">
                  — {FORM_LABELS[user.form_id] || user.form_id}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnlinePresence;
